var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToothpaste({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1526,
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M460.448 709.108H316.86L297.28 207.152h182.748z",
    fill: "#FD919F",
    "p-id": 1528
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M421.288 778.288H356.02l-39.16-69.18h143.588z",
    fill: "#D5E6F7",
    "p-id": 1529
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M356.02 778.288h65.268v74.404H356.02z",
    fill: "#7BABF3",
    "p-id": 1530
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M421.288 207.152l-19.58 501.956h58.74l19.58-501.956z",
    fill: "#E0667D",
    "p-id": 1531
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M705.048 430.056a29.472 29.472 0 0 1-29.472-29.472V239.888a84.252 84.252 0 0 1 24.828-59.952 29.476 29.476 0 0 1 41.68 41.68 25.664 25.664 0 0 0-7.568 18.272v160.7a29.464 29.464 0 0 1-29.468 29.468z",
    fill: "#FD919F",
    "p-id": 1532
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M587.168 240.832h88.412v189.224h-88.412z",
    fill: "#FFFFFF",
    "p-id": 1533
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M594.184 852.696a29.472 29.472 0 0 1-29.472-29.472v-293.072l-34.26-83.008a29.48 29.48 0 0 1-2.228-11.244v-199.28a29.472 29.472 0 1 1 58.944 0v193.432l34.26 83.008a29.48 29.48 0 0 1 2.228 11.244v298.916a29.472 29.472 0 0 1-29.472 29.476z",
    fill: "#A0D1F2",
    "p-id": 1534
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M594.188 864.696c-22.868 0-41.472-18.604-41.472-41.472v-290.692l-33.356-80.812a41.36 41.36 0 0 1-3.132-15.82v-199.28c0-22.868 18.6-41.468 41.468-41.468s41.472 18.6 41.472 41.468v191.056l33.352 80.808a41.28 41.28 0 0 1 3.136 15.824v298.916c0 22.864-18.6 41.472-41.468 41.472z m-36.492-645.544a17.488 17.488 0 0 0-17.468 17.468v199.276c0 2.296 0.444 4.544 1.324 6.672l34.256 83.004c0.596 1.452 0.908 3.008 0.908 4.58v293.072c0 9.632 7.84 17.472 17.472 17.472s17.468-7.84 17.468-17.472v-298.916a17.4 17.4 0 0 0-1.324-6.672l-34.256-83.004a12.068 12.068 0 0 1-0.908-4.58V236.62a17.492 17.492 0 0 0-17.472-17.468z",
    fill: "#504774",
    "p-id": 1535
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M675.58 442.056h-88.412a12 12 0 0 1-12-12V240.832a12 12 0 0 1 12-12h88.412a12 12 0 0 1 12 12v189.224a12 12 0 0 1-12 12z m-76.412-24h64.412V252.832h-64.412v165.224z",
    fill: "#504774",
    "p-id": 1536
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M675.58 311.656h-37.892a12 12 0 1 1 0-24h37.892a12 12 0 1 1 0 24zM675.58 383.232h-37.892a12 12 0 1 1 0-24h37.892a12 12 0 1 1 0 24z",
    fill: "#504774",
    "p-id": 1537
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M705.052 442.056c-22.868 0-41.472-18.6-41.472-41.468V239.888a96.176 96.176 0 0 1 28.34-68.436 41.224 41.224 0 0 1 29.328-12.144c11.08 0 21.492 4.312 29.324 12.14 16.168 16.172 16.168 42.484 0.008 58.652a13.732 13.732 0 0 0-4.06 9.788v160.7c0 22.864-18.604 41.468-41.468 41.468z m16.196-258.752a17.372 17.372 0 0 0-12.36 5.116 72.32 72.32 0 0 0-21.308 51.464v160.7c0 9.632 7.84 17.468 17.472 17.468s17.468-7.836 17.468-17.468V239.888c0-10.112 3.936-19.616 11.088-26.76a17.5 17.5 0 0 0-0.008-24.708 17.34 17.34 0 0 0-12.352-5.116zM460.444 721.104H316.86a12 12 0 0 1-11.992-11.532L285.288 207.62a12.02 12.02 0 0 1 11.992-12.468h182.748a12.02 12.02 0 0 1 11.992 12.468l-19.584 501.952a12 12 0 0 1-11.992 11.532z m-132.04-24h120.504l18.644-477.952H309.756l18.648 477.952z",
    fill: "#504774",
    "p-id": 1538
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M421.288 790.288H356.02a11.988 11.988 0 0 1-10.44-6.088l-39.16-69.184a12 12 0 0 1 10.444-17.908h143.584a12.004 12.004 0 0 1 10.448 17.908l-39.16 69.184a12.02 12.02 0 0 1-10.448 6.088z m-58.272-24h51.276l25.572-45.184H337.44l25.576 45.184z",
    fill: "#504774",
    "p-id": 1539
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M421.288 790.288H356.02a11.988 11.988 0 0 1-10.44-6.088l-39.16-69.184a12 12 0 0 1 10.444-17.908h143.584a12.004 12.004 0 0 1 10.448 17.908l-39.16 69.184a12.02 12.02 0 0 1-10.448 6.088z m-58.272-24h51.276l25.572-45.184H337.44l25.576 45.184z",
    fill: "#504774",
    "p-id": 1540
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M421.288 864.696H356.02a12 12 0 0 1-12-12v-74.408a12 12 0 0 1 12-12h65.268a12 12 0 0 1 12 12v74.408a12 12 0 0 1-12 12z m-53.268-24h41.268v-50.408H368.02v50.408zM401.716 721.108l-0.476-0.008a12 12 0 0 1-11.524-12.46l19.584-501.956c0.256-6.616 5.808-11.656 12.46-11.524a12 12 0 0 1 11.524 12.46l-19.584 501.956a12.004 12.004 0 0 1-11.984 11.532z",
    fill: "#504774",
    "p-id": 1541
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToothpaste);
export default __webpack_public_path__ + "static/media/toothpaste.699b5d358124e48f93a05ccd68242bbc.svg";
export { ForwardRef as ReactComponent };